
<div
  *ngFor="let event of unsubscribedEvents"
  class="event"
  [routerLink]="[ '/Veranstaltungen/visualisieren' ]"
  [queryParams]="{ id: event.id }"
>
  {{event.name}}
</div>

<div
  *ngIf="!bLoading && !unsubscribedEvents.length"
  class="noElements"
>
  Keine abonnierten Veranstaltungen
</div>
